module.exports = __webpack_public_path__ + "img/sparks-green-small.b936386e.png";